if (!window.Eurus.loadedScript.includes('next-day-delivery.js')) {
  window.Eurus.loadedScript.push('next-day-delivery.js');

  function formatMinutesRemaining(totalMinutes) {
    if (totalMinutes <= 0) return null;

    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
      return (
        hours +
        (hours === 1 ? ' hour ' : ' hours ') +
        minutes +
        (minutes === 1 ? ' minute' : ' minutes')
      );
    }

    if (hours > 0) {
      return hours + (hours === 1 ? ' hour' : ' hours');
    }

    return minutes + (minutes === 1 ? ' minute' : ' minutes');
  }

  function initNextDayDelivery(el) {
    if (!el || el.dataset.nddInitialized === 'true') return;

    var minutesRemaining = parseInt(el.getAttribute('data-minutes-remaining'), 10);
    var timeEl = el.querySelector('[data-ndd-time]');

    if (!timeEl || isNaN(minutesRemaining)) return;

    el.dataset.nddInitialized = 'true';

    function render() {
      if (minutesRemaining <= 0) {
        el.remove();
        return;
      }

      var formatted = formatMinutesRemaining(minutesRemaining);
      if (formatted) {
        timeEl.textContent = formatted;
      }
    }

    render();

    window.setInterval(function () {
      minutesRemaining -= 1;
      render();
    }, 60000);
  }

  function initAll() {
    document.querySelectorAll('[data-next-day-delivery]').forEach(initNextDayDelivery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
}